/* eslint-disable jsx-a11y/no-onchange */
import React from "react";
import styled from "styled-components";
import { navigate, Link } from "gatsby";

import { BreadCrumb, FormControlLabel } from "../components/section";
import PhoneLineIcon from "../components/Icons/PhoneLineIcon";
import PaperPlanIcon from "../components/Icons/PaperPlanIcon";
import Layout from "../components/layout";
import SEO from "../components/seo";
import FormButton from "../components/button/FormButton";
import BreakpointUp from "../components/Media/BreakpointUp";
import BreakpointDown from "../components/Media/BreakpointDown";
import HoneypotField from "../components/HoneypotField";
import { HONEYPOT_FIELD, validateLead, hasErrors } from "../utils/leadValidation";
import {
	submitLead,
	captureAttribution,
	getStoredAttribution,
	pushLeadConversion,
	GENERIC_ERROR
} from "../utils/submitLead";

const ContactGrid = styled.div`	
	display:flex;
	flex-wrap:wrap;
	align-items:center;
	margin:0 -15px; 
	${BreakpointDown.lg`
		flex-direction:column-reverse;
	`}
`;

const AddressColumn = styled.div`    
	width:100%;
	padding:0 15px;
	position:relative;
	z-index:2;
	margin-bottom:30px;
	${BreakpointUp.lg`				
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%;
	`}
	& h2{
		font-size:20px;
		line-height:28px;
		color:#020304;
		font-family: 'Roboto', serif;
		margin-bottom:20px;
	}
`;

const FormColumn = styled.div`
	width:100%;
	padding:0 15px;
	position:relative;
	z-index:1;
	margin-bottom:30px;
	${BreakpointUp.lg`				
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%;
	`}
	& h1{
		margin-bottom: 25px;
		margin-top:15px;
		font-size:28px;
		line-height:38px;
		${BreakpointUp.md`	
			font-size:34px;
			line-height:44px;
		`}
	}

	& p{       
		margin-bottom:40px;
	}
`;

const FormGrid = styled.div`	
	display: grid;
	align-items: center;
	grid-column-gap: 30px;
	grid-template-columns: repeat(1, 1fr);
	${BreakpointUp.sm`
		grid-row-gap: 30px;
		grid-template-columns: repeat(2, 1fr);      
	`}
`;

const GridItem = styled.div`	
	display:flex;
	align-items:center;
	margin:0 -10px 40px -10px;
`;

const Icon = styled.div`	
	display: flex;
	align-items: center;
	justify-content:center;
	width:48px;
	height:48px;
	border-radius:50%;
	background-color:#fff;
	border:1px solid #ddd;
	padding:0 10px;
`;

const TextWrap = styled.div`	
	display:inline-block;
	verticle-align:middle;	
	padding:0 10px;
	& span{
		display:block;
	}
	& p{
		font-size:18px;
		font-weight:700;
		color:#020304;  
		margin-bottom:0;     
	}
	& a{
		font-size:18px;
		font-weight:700;
		color:#020304;
		text-decoration:underline;
		&:hover{
			text-decoration:none; 
			color:#020304;
		}
	}
`;

const SectionContact = styled.div`	
	position:relative;
	overflow:hidden;
	padding:140px 0 30px 0;
	${BreakpointUp.lg`			
		padding:140px 0 150px 0;
		// &:before{
		//     content: '';
		//     left: -500px;
		//     top: 0;
		//     bottom: 0;
		//     width: 1160px;
		//     height: 1160px;
		//     border-radius: 0 50% 50% 0;
		//     display: block;
		//     background-color:#F6F6F6;
		//     position: absolute;
		//     z-index: 1;
		// }
		// &:after{
		//     content: '';
		//     left: -350px;
		//     top: 0;
		//     bottom: 0;
		//     width: 1160px;
		//     height: 1160px;
		//     border-radius: 0 50% 50% 0;
		//     display: block;
		//     position: absolute;
		//     background-color: #FAFAFA;
		// }
	`}	
`;
class ContactUsPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			first_name: '',
			last_name: '',
			email: '',
			phone_no: '',
			state: '',
			city: '',
			comment: '',
			[HONEYPOT_FIELD]: '',
			errors: {},
			formError: '',
			submitting: false
		}

		this.handleChange = this.handleChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		captureAttribution();
	}

	handleChange(event) {
		const { id, value } = event.target
		this.setState(prevState => ({
			[id]: value,
			errors: { ...prevState.errors, [id]: '' }
		}))
	}

	async handleSubmit(event) {
		event.preventDefault()
		if (this.state.submitting) return;

		const fields = {
			first_name: this.state.first_name,
			last_name: this.state.last_name,
			email: this.state.email,
			phone_no: this.state.phone_no,
			state: this.state.state,
			comment: this.state.comment
		};

		const errors = validateLead(fields);
		if (hasErrors(errors)) {
			this.setState({ errors, formError: '' });
			return;
		}

		const { location } = this.props;
		const attribution = getStoredAttribution();
		const data = {
			source: location.origin,
			form: "Contact Us",
			page: window.location.href,
			first_name: this.state.first_name,
			last_name: this.state.last_name,
			email: this.state.email,
			phone_no: this.state.phone_no,
			state: this.state.state,
			city: this.state.city,
			comment: this.state.comment,
			utm_medium: attribution.utm_medium,
			utm_term: attribution.utm_term,
			utm_campaign: attribution.utm_campaign,
			utm_content: attribution.utm_content,
			lead_source: attribution.lead_source,
			[HONEYPOT_FIELD]: this.state[HONEYPOT_FIELD]
		}

		this.setState({ submitting: true, formError: '', errors: {} });

		try {
			await submitLead(data);

			pushLeadConversion({ email: this.state.email, phone: this.state.phone_no });

			this.setState({ first_name: '', last_name: '', email: '', phone_no: '', state: '', city: '', comment: '', submitting: false });
			navigate("/thanks");
		} catch (error) {
			this.setState({
				submitting: false,
				errors: error.fieldErrors || {},
				formError: error.message || GENERIC_ERROR
			});
		}
	}
	render() {
		const { location } = this.props;
		return (
			<Layout location={location}>
				<SEO title="Contact Us" />
				<SectionContact>
					<div className="container">
						<BreadCrumb><Link to='/'>Home</Link>/<span>Contact Us</span></BreadCrumb>
						<ContactGrid>
							<AddressColumn>
								<h2>Contact Information</h2>
								<GridItem>
									<Icon><PhoneLineIcon /></Icon>
									<TextWrap>
										<span>Phone Number</span>
										<p>
											<a href="tel:8776005980">
												(877) 600-5980
											</a>
										</p>
									</TextWrap>
								</GridItem>
								<GridItem>
									<Icon><PaperPlanIcon /></Icon>
									<TextWrap>
										<span>Email ID</span>
										<a href="mailto:sales@premiermetalstructures.com">sales@premiermetalstructures.com</a>
									</TextWrap>
								</GridItem>
							</AddressColumn>
							<FormColumn>
								<h1>Get in touch</h1>
								<form id="contactform" onSubmit={this.handleSubmit} noValidate>
									<FormGrid>
										<div className="form-group-bordered">
											<input type="text" id="first_name" className="form-control" value={this.state.first_name} onChange={this.handleChange} required />
											<FormControlLabel className={this.state.first_name !== '' ? "control-label active" : "control-label"}>First Name</FormControlLabel>
											{this.state.errors.first_name && <span className="form-error">{this.state.errors.first_name}</span>}
										</div>
										<div className="form-group-bordered">
											<input type="text" id="last_name" className="form-control" value={this.state.last_name} onChange={this.handleChange} required />
											<FormControlLabel className={this.state.last_name !== '' ? "control-label active" : "control-label"}>Last Name</FormControlLabel>
											{this.state.errors.last_name && <span className="form-error">{this.state.errors.last_name}</span>}
										</div>
										<div className="form-group-bordered">
											<input type="email" id="email" className="form-control" value={this.state.email} onChange={this.handleChange} required />
											<FormControlLabel className={this.state.email !== '' ? "control-label active" : "control-label"}>Email Address</FormControlLabel>
											{this.state.errors.email && <span className="form-error">{this.state.errors.email}</span>}
										</div>
										<div className="form-group-bordered">
											<input type="tel" id="phone_no" className="form-control" value={this.state.phone_no} onChange={this.handleChange} required />
											<FormControlLabel className={this.state.phone_no !== '' ? "control-label active" : "control-label"}>Phone Number</FormControlLabel>
											{this.state.errors.phone_no && <span className="form-error">{this.state.errors.phone_no}</span>}
										</div>
										<div className="form-group-bordered">
											<select id="state" className="form-control" value={this.state.state} onChange={this.handleChange}>
												<option value="">State</option>
												<option value="AL">Alabama</option>
												<option value="AK">Alaska</option>
												<option value="AZ">Arizona</option>
												<option value="AR">Arkansas</option>
												<option value="CA">California</option>
												<option value="CO">Colorado</option>
												<option value="CT">Connecticut</option>
												<option value="DE">Delaware</option>
												<option value="DC">District Of Columbia</option>
												<option value="FL">Florida</option>
												<option value="GA">Georgia</option>
												<option value="HI">Hawaii</option>
												<option value="ID">Idaho</option>
												<option value="IL">Illinois</option>
												<option value="IN">Indiana</option>
												<option value="IA">Iowa</option>
												<option value="KS">Kansas</option>
												<option value="KY">Kentucky</option>
												<option value="LA">Louisiana</option>
												<option value="ME">Maine</option>
												<option value="MD">Maryland</option>
												<option value="MA">Massachusetts</option>
												<option value="MI">Michigan</option>
												<option value="MN">Minnesota</option>
												<option value="MS">Mississippi</option>
												<option value="MO">Missouri</option>
												<option value="MT">Montana</option>
												<option value="NE">Nebraska</option>
												<option value="NV">Nevada</option>
												<option value="NH">New Hampshire</option>
												<option value="NJ">New Jersey</option>
												<option value="NM">New Mexico</option>
												<option value="NY">New York</option>
												<option value="NC">North Carolina</option>
												<option value="ND">North Dakota</option>
												<option value="OH">Ohio</option>
												<option value="OK">Oklahoma</option>
												<option value="OR">Oregon</option>
												<option value="PA">Pennsylvania</option>
												<option value="RI">Rhode Island</option>
												<option value="SC">South Carolina</option>
												<option value="SD">South Dakota</option>
												<option value="TN">Tennessee</option>
												<option value="TX">Texas</option>
												<option value="UT">Utah</option>
												<option value="VT">Vermont</option>
												<option value="VA">Virginia</option>
												<option value="WA">Washington</option>
												<option value="WV">West Virginia</option>
												<option value="WI">Wisconsin</option>
												<option value="WY">Wyoming</option>
											</select>
											{this.state.errors.state && <span className="form-error">{this.state.errors.state}</span>}
										</div>
									</FormGrid>
									<div className="form-group-bordered">
										<textarea id="comment" className="form-control" value={this.state.comment} onChange={this.handleChange} required />
										<FormControlLabel className={this.state.comment !== '' ? "control-label active" : "control-label"}>Write your comment here…</FormControlLabel>
										{this.state.errors.comment && <span className="form-error">{this.state.errors.comment}</span>}
									</div>
									<HoneypotField value={this.state[HONEYPOT_FIELD]} onChange={this.handleChange} />
									{this.state.formError && <div className="form-error form-error-summary">{this.state.formError}</div>}
									<div className="form-action">
										<FormButton text={this.state.submitting ? "Submitting..." : "Submit"} />
									</div>
								</form>
							</FormColumn>
						</ContactGrid>
					</div>
				</SectionContact>
			</Layout>
		)
	}
};

export default ContactUsPage;